<template>
    <div v-if="needRefresh"
        class="fixed bottom- safe-area-bottom left-1/2 -translate-x-1/2 md:bottom-6 mb-4 md:mb-0 z-[9999] bg-slate-900/95 dark:bg-slate-800/95 backdrop-blur-md shadow-2xl rounded-full p-2 pr-3 pl-4 flex items-center justify-between text-white animate-in slide-in-from-bottom border border-slate-700 w-[90%] md:w-auto max-w-sm">

        <div class="flex items-center gap-3 min-w-0 pr-4">
            <div class="relative">
                <RefreshCw :size="16" class="text-blue-400" />
                <span class="absolute -top-1 -right-1 flex h-2 w-2">
                    <span
                        class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                    <span class="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
                </span>
            </div>
            <div class="text-sm font-medium truncate">Update available</div>
        </div>

        <div class="flex gap-1 items-center shrink-0">
            <button @click="updateServiceWorker(true)"
                class="bg-blue-600 hover:bg-blue-500 text-white px-3 py-1.5 text-xs font-bold rounded-full transition-all whitespace-nowrap">
                Update
            </button>
            <button @click="needRefresh = false"
                class="p-1.5 hover:bg-white/10 rounded-full transition-colors text-slate-400" aria-label="Dismiss">
                <X :size="16" />
            </button>
        </div>
    </div>

    <div v-if="offlineReady"
        class="fixed bottom- safe-area-bottom left-1/2 -translate-x-1/2 md:bottom-6 mb-4 md:mb-0 z-[9999] bg-emerald-600/95 backdrop-blur-md shadow-2xl rounded-full p-2 pr-3 pl-4 flex items-center justify-between text-white animate-in fade-in slide-in-from-bottom border border-emerald-500/50 w-[90%] md:w-auto min-w-[200px]">

        <div class="flex items-center gap-3 pr-4">
            <CheckCircle2 :size="16" class="text-emerald-200" />
            <div class="text-sm font-medium">Ready for offline use</div>
        </div>

        <button @click="offlineReady = false"
            class="p-1.5 hover:bg-white/20 rounded-full transition-colors text-emerald-100 shrink-0">
            <X :size="16" />
        </button>
    </div>
</template>

<script setup>
import { RefreshCw, X, CheckCircle2 } from 'lucide-vue-next'
import { usePWA } from '@/composables/usePWA'

const { needRefresh, offlineReady, updateServiceWorker } = usePWA()
</script>

<style scoped>
.safe-area-bottom {
    margin-bottom: env(safe-area-inset-bottom);
}

.animate-spin-slow {
    animation: spin 3s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>
